import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IDatiqLog } from '../../models';
import * as DatiqLogActions from '../datiq-log.actions';
import * as DatiqLogSelectors from '../datiq-log.selectors';
import { IDatiqLogStoreService } from './models';

@Injectable({
    providedIn: 'root',
})
export class DatiqLogStoreService implements IDatiqLogStoreService {
    constructor(private _store: Store) {}

    log(message: string, info?: unknown): void {
        this._store.dispatch(
            DatiqLogActions.log({
                message,
                info,
            })
        );
    }
    error(message: string, info?: unknown): void {
        this._store.dispatch(
            DatiqLogActions.error({
                message,
                info,
            })
        );
    }
    warn(message: string, info?: unknown): void {
        this._store.dispatch(
            DatiqLogActions.warn({
                message,
                info,
            })
        );
    }
    debug(message: string, info?: unknown): void {
        this._store.dispatch(
            DatiqLogActions.debug({
                message,
                info,
            })
        );
    }

    jsError(message: string, error: Error, info: unknown) {
        this._store.dispatch(
            DatiqLogActions.jsError({
                message,
                error,
                info,
            })
        );
    }

    getLogs$(): Observable<IDatiqLog[]> {
        return this._store.select(DatiqLogSelectors.getLogs());
    }
}
